// Copyright 2024, Imprivata, Inc.  All rights reserved.

import { ConfigProvider } from 'antd';
import enUS from 'antd/lib/locale/en_US';
import esES from 'antd/lib/locale/es_ES';
import frFR from 'antd/lib/locale/fr_FR';
import deDE from 'antd/lib/locale/de_DE';
import itIT from 'antd/lib/locale/it_IT';
import ptBR from 'antd/lib/locale/pt_BR';
import nlNL from 'antd/lib/locale/nl_NL';

import { type ReactNode, Suspense } from 'react';
import { I18nextProvider, useTranslation } from 'react-i18next';
import  i18n from './config';

export const antLocales: Record<string, any> = {
  en: enUS,
  es: esES,
  fr: frFR,
  de: deDE,
  it: itIT,
  pt: ptBR,
  nl: nlNL,
};

const InnerLocaleProvider = ({ children }: { children: ReactNode }) => {
  const { i18n: i18next } = useTranslation();
  const lang = (i18next.resolvedLanguage || i18next.language || 'en').split('-')[0];

  return <ConfigProvider locale={antLocales[lang] || enUS}>{children}</ConfigProvider>;
};

export const LocaleProvider = ({ children }: { children: ReactNode }) => {
  return (
    <Suspense fallback={<div>...Loading</div>}>
      <I18nextProvider i18n={i18n} defaultNS="translation">
        <InnerLocaleProvider>{children}</InnerLocaleProvider>
      </I18nextProvider>
    </Suspense>
  );
};
